/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEmploymentsForMerchant} from '../api'

 export const useQueryGetEmploymentsForMerchant = createReactQueryHook('getEmploymentsForMerchant', getEmploymentsForMerchant)
